import { FileSignature, Scale } from 'lucide-react'
import { CLAUSE_COPY } from '../i18n/modes/clauses'
import type { ClauseFact, Language } from '../types/document'

/** Clauses to read before signing, each with its key figure and the exact line. */
export function ClauseList({ clauses, language, docSays }: { clauses: ClauseFact[]; language: Language; docSays: string }) {
  const copy = CLAUSE_COPY[language] ?? CLAUSE_COPY.en
  return (
    <section className="clause-list" aria-label={copy.title}>
      <h2>
        <FileSignature size={20} aria-hidden="true" /> {copy.title}
      </h2>
      {clauses.length === 0 ? (
        <p className="field-hint">{copy.none}</p>
      ) : (
        <ul>
          {clauses.map((c, i) => {
            const t = copy.clauses[c.kind]
            return (
              <li key={i} className={`clause-item clause-${c.kind}`}>
                <div className="clause-head">
                  <strong>{t.title}</strong>
                  {c.value && <span className="clause-figure">{c.value}</span>}
                </div>
                <p>{t.check}</p>
                <blockquote className="evidence">
                  <span className="evidence-label">{docSays}</span>
                  {c.evidence}
                </blockquote>
              </li>
            )
          })}
        </ul>
      )}
      <p className="clause-safety">
        <Scale size={16} aria-hidden="true" /> {copy.safety}
      </p>
    </section>
  )
}
